(() => {
    const hero = document.querySelector("[data-hero]");
    if (!hero) return;

    const media = hero.querySelector("[data-hero-media]");
    const data = hero.querySelector("[data-desktop-video]");

    if (!media || !data) return;

    const mobile = window.matchMedia("(max-width:990px)").matches;

    const src = mobile
        ? data.dataset.mobileVideo
        : data.dataset.desktopVideo;

    if (!src) return;

    const poster = mobile
        ? data.dataset.mobilePoster
        : data.dataset.desktopPoster;

    const loadVideo = () => {

        const video = document.createElement("video");

        video.className = "img-vid-cover";
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = "metadata";
        video.poster = poster;

        const source = document.createElement("source");
        source.src = src;
        source.type = "video/mp4";

        video.appendChild(source);

        video.addEventListener("loadeddata", () => {
            media.replaceWith(video);
        });

        video.load();

    };

    if ("requestIdleCallback" in window) {
        requestIdleCallback(loadVideo);
    } else {
        window.addEventListener("load", loadVideo, { once: true });
    }

})();